import config from '@/config';
import { PlanCode, StripePlan } from '@/types/config';

export const DEFAULT_PLAN_CODE: PlanCode = 'listing';

export function isPlanCode(value: unknown): value is PlanCode {
  return value === 'listing' || value === 'video_launch';
}

export function getPlanByCode(value: unknown): StripePlan | undefined {
  if (!isPlanCode(value)) return undefined;
  return config.stripe.plans.find((plan) => plan.planCode === value);
}

export function getPlanByPriceId(priceId: unknown): StripePlan | undefined {
  if (typeof priceId !== 'string') return undefined;
  return config.stripe.plans.find((plan) => plan.priceId === priceId);
}

export function getSelectedPlan(value: unknown): StripePlan {
  return getPlanByCode(value) || getPlanByCode(DEFAULT_PLAN_CODE)!;
}

export function formatPlanPrice(plan: StripePlan): string {
  return plan.price.toFixed(2);
}
